//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

	name: "latte-user-avatar",

	props: {

		isOnline: {
			default: false,
			required: false,
			type: Boolean
		},

		isProfile: {
			default: false,
			required: false,
			type: Boolean
		},

		profilePicture: {
			default: null,
			required: false,
			type: String | null
		},

		userId: {
			default: 0,
			required: true,
			type: Number
		},

		userName: {
			default: "",
			required: true,
			type: String
		}

	},

	beforeUpdate()
	{
		this.tooltipText = this.$el && this.$el.classList.contains("with-tooltip") ? this.userName : undefined;
	},

	data()
	{
		return {
			tooltipText: ""
		};
	},

	mounted()
	{
		this.tooltipText = this.$el && this.$el.classList.contains("with-tooltip") ? this.userName : undefined;
	},

	computed: {

		avatarStyles()
		{
			return {
				backgroundImage: `url(${this.profilePicture})`
			};
		},

		initials()
		{
			const parts = this.userName.split(" ");

			if (parts.length === 0)
				return "?";

			if (parts.length === 1)
				return parts[0].substr(0, 1);

			return `${parts[0].substr(0, 1)}${parts[parts.length - 1].substr(0, 1)}`;
		},

		initialsStyles()
		{
			return {
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				borderRadius: "inherit"
			};
		}

	},

	methods: {

		onAvatarClicked()
		{
			if (this.isProfile)
				return;

			Latte.action.dispatch("latte:mini-profile:open", {userId: this.userId}, this.$el);
		}

	}

}

